import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { FontWeight, TextSize, TextTransform } from '@freelancer/ui/text';
import { textVariants } from '../text';
import { HrColor } from './hr.model';

@Component({
  standalone: true,
  selector: 'fl-hr',
  template: `
    @if (label) {
      <p [class]="labelClass">
        {{ label }}
      </p>
    }
  `,
  styleUrls: ['./hr.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HrComponent implements OnChanges, OnInit {
  @Input() label: string;

  @Input()
  @HostBinding('attr.data-color')
  color = HrColor.LIGHT;

  /**
   * The text size to apply to the label.
   */
  @Input() textSize: TextSize = TextSize.BODY_16;

  /**
   * The text transform to apply to the label.
   */
  @Input() textTransform: TextTransform = TextTransform.UPPERCASE;

  /**
   * The font weight to apply to the label.
   */
  @Input() fontWeight: FontWeight = FontWeight.BOLD;

  labelClass: string;

  ngOnInit(): void {
    this.calculateStyles();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      'textSize' in changes ||
      'textTransform' in changes ||
      'fontWeight' in changes
    ) {
      this.calculateStyles();
    }
  }

  private calculateStyles(): void {
    this.labelClass = textVariants({
      size: this.textSize,
      transform: this.textTransform,
      weight: this.fontWeight,
      class: 'HrText',
    });
  }
}
